import React from "react";
import ContactSection from "../components/ContactSection";
import SEO from "../components/SEO";

const ContactsPage = () => (
  <>
    <SEO
      title="Contatti | Supporto Kyros Games"
      description="Contatta Kyros Games per supporto su giochi autoprodotti, account, Store, launcher, stampa e contenuti."
      canonical="https://kyrosgames.com/contact"
      structuredData={{
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "WebPage",
            "@id": "https://kyrosgames.com/contact#webpage",
            "url": "https://kyrosgames.com/contact",
            "name": "Contatti | Supporto Kyros Games",
            "inLanguage": "it-IT",
            "isPartOf": { "@id": "https://kyrosgames.com/#website" },
            "breadcrumb": { "@id": "https://kyrosgames.com/contact#breadcrumb" }
          },
          {
            "@type": "BreadcrumbList",
            "@id": "https://kyrosgames.com/contact#breadcrumb",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://kyrosgames.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Contatti",
                "item": "https://kyrosgames.com/contact"
              }
            ]
          }
        ]
      }}
    />
    <ContactSection />
  </>
);

export default ContactsPage;
